import {
  DedicatedDriverPreferencesOutput,
  UpdateDedicatedDriverPreferencesInput,
} from '@allocab/allocab-dedicated-driver-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';
import { ToastManager } from '../services/toast/utils';
import { t } from '../services/translation/translation';

const createDriverPreferences = async (
  id: string,
  input: UpdateDedicatedDriverPreferencesInput,
): Promise<DedicatedDriverPreferencesOutput> => {
  return await driverApi.put<UpdateDedicatedDriverPreferencesInput, DedicatedDriverPreferencesOutput>(
    `/v1/dedicated-driver-preferences/driver/${id}`,
    input,
  );
};

export const useCreateDriverPreferences = (id: string) =>
  useMutation<DedicatedDriverPreferencesOutput, unknown, UpdateDedicatedDriverPreferencesInput>({
    mutationFn: input => createDriverPreferences(id, input),
    onSuccess: preferences => {
      ToastManager.show({ message: t('driver-preferences.create'), severity: 'success' });
      queryClient.invalidateQueries(queryKeys.user.fetchDriversPreferencesData());
      queryClient.setQueryData(queryKeys.user.fetchDrivePreferencesById(id), preferences);
    },
  });
